export default () => ({
  userInfo: {
    Display: "",
    Pass: "",
    Realm: "",
    User: "",
    WSServer: "",
    Token: "",
    User_id: "",
    ShortName: "",
    Avatar: "",
    LoggedInPass: "",
    Username: "",
    PbxServer: "",
    VoiceAgentUrl: "",
    userCompany: "",
    audioSipmovil: true,
    audioJoin: true,
    in_call_number_blocked: false,
    out_call_number_blocked: false,
    twoFactorEnabled: false,
    mail: '',
    crm_chat_enabled: false,
    // task_notas_voz: velocidad de reproducción de notas de voz (1 | 1.5 | 2).
    playbackRate: 1,
  },
  userInfoSipmovil: { //Object response from a Sipmovil Logged-in user
    token: "",
    shortName: "",
    avatar:"",
    userId:"",
    sipData: {},
    asteriskServer: {},
    mail: "",
    logIn: "",
  },
  companyInfo: {
    id: "",
    name: "",
    user: "",
    ari_password: "",
    pre_translation: "",
    config_did: "",
    address: "",
    phone: "",
    sipmovil_trunk: "",
    voicemail_extension: "",
    cellphone: "",
    record_format: "",
    asterisk_server: "",
    country: "",
    logo_crop: "",
    web_page: "",
    slug_name: "",
    email: "",
    record_manage: "",
    city: "",
    plan: "",
    id_switch: "",
    id_switch_client: "",
    logo: "",
    block_conference_record: "",
    share_contacts: "",
    currency: "",
  },
});